import {useAppSelector} from "common/hook";
import {useEffect, useRef, useState} from "react";
import {headerItems} from "components/header/contacts/index";
import useBeforeInstallPrompt from "common/hook/useBeforeInstallPrompt";

export const Contacts = () => {
    const {handleInstallClick, choiceResult,installPromptRef} = useBeforeInstallPrompt();
    const roleType = useAppSelector((state) => state.role.roleType);

    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        const userAgent = window.navigator.userAgent;
        setIsIOS(/iPad|iPhone|iPod/.test(userAgent));
    }, []);


    const isAppInstalled = choiceResult && choiceResult.outcome === 'accepted';

    const installPrompt = installPromptRef.current !== null;

    const currentYear = new Date().getFullYear();

    return (
        <div className="hdr-contacts">
            {headerItems.map((item, index) => (
                (item.userType === 'all' || item.userType === roleType) && (
                    <div key={index} className="item">
                        {item.link ? (
                            <p className="p-icon">
                                <a className='hover' href={item.link}>{item.title}</a>
                                <span className="icon">{item.icon}</span>
                            </p>
                        ) : (
                            item.tell && (
                                <>
                                    <span className="contact-person">{item.title}</span>
                                    <p className="p-icon">
                                        <a className='hover' href={item.path}>{item.tell}</a>
                                        <span className="icon">{item.icon}</span>
                                    </p>
                                </>
                            )
                        )}

                        {(!isIOS && !isAppInstalled && installPrompt && item.appText) && (
                            <p className="p-icon">
                                <button onClick={handleInstallClick}
                                        className="js-install-pwa hover">{item.appText}</button>
                                <span className="icon">{item.icon}</span>
                            </p>
                        )}

                    </div>
                )
            ))}
            <p className="copy">Online Class &copy; {currentYear}</p>
        </div>
    );
}
